import React from 'react';

const Cart = () => {
  return (
    <svg
      version="1.1"
      id="cart_icon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 48 43"
      style="enable-background:new 0 0 48 43;"
      space="preserve"
      style={{
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 22.9256,
        verticalAlign: 'middle',
      }}
    >
      <path d="M21.28,33.72c2.22,0,4.02,1.8,4.02,4.02c0,2.22-1.8,4.02-4.02,4.02c-2.22,0-4.02-1.8-4.02-4.02 C17.26,35.52,19.06,33.72,21.28,33.72L21.28,33.72z" />
      <path d="M36.75,33.72c2.22,0,4.02,1.8,4.02,4.02c0,2.22-1.8,4.02-4.02,4.02s-4.02-1.8-4.02-4.02 C32.73,35.52,34.53,33.72,36.75,33.72L36.75,33.72z" />
      <polyline points="1.56,1.88 9.73,1.88 17.31,26.63 42.66,26.63 " />
      <line x1="15.88" y1="20.13" x2="45.33" y2="20.13" />
      <line x1="13.92" y1="13.61" x2="47" y2="13.61" />
    </svg>
  );
};

export default Cart;
